import { useTranslation } from 'react-i18next';
import './footer.scss';

const AGENCY_URL = 'https://alea.pro';

export interface FooterProps {
  className?: string;
}

/**
 * Footer - Application footer with links and text
 *
 * Features:
 * - Two sections with translatable content
 * - Link support
 * - Configurable visibility per page
 * - Responsive design with adequate padding
 */
export function Footer({ className = '' }: FooterProps) {
  const { t } = useTranslation();

  return (
    <footer className={`footer ${className}`}>
      <div className="footer__container">
        {/* First section */}
        <div className="footer__section">
          <p className="footer__text">
            {t('footer.section1_text')}
          </p>
        </div>

        {/* Second section */}
        <div className="footer__section">
          <p className="footer__text">
            <a
              href={AGENCY_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer.section1_link_text')}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
